define('views/content/timeline',['require','backbone','collections/wallet_histories','collections/action_histories','views/components/timeline/timeline_blocks','text!templates/content/timeline.html'],function(require){

    var Backbone = require('backbone');
    var WalletsCollection = require('collections/wallet_histories');
    var ActionsCollection = require('collections/action_histories');
    var ActionView = require('views/components/timeline/timeline_blocks');

    var temp = require("text!templates/content/timeline.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'timeline-page',
        titleKey: 'timeline',

        initialize: function(options) {

            this.loading = false;
            this.limit = 4;

            _.bindAll(this, 'onScroll');
            // bind to window
            $(window).scroll(this.onScroll);

            App.context.changePageTitle(App.polyglot.t(this.titleKey));


            if (App.user.get("country_distributor")){
                this.WalletsCollection = new WalletsCollection([], {
                    parameters: {
                        'cd_id': App.user.get("country_distributor")
                    }
                }
                );
                this.ActionsCollection = new ActionsCollection([], {
                    parameters: {
                        'cd_id': App.user.get("country_distributor")
                    }
                }
                );
            }
            else if (App.user.get("distributor")){
                this.WalletsCollection = new WalletsCollection([], {
                    parameters: {
                        'distributor_id': App.user.get("distributor")
                    }
                }
                );
                this.ActionsCollection = new ActionsCollection([], {
                    parameters: {
                        'distributor_id': App.user.get("distributor")
                    }
                }
                );
            }
            else if (App.user.get("reseller")){
                this.WalletsCollection = new WalletsCollection([], {
                    parameters: {
                        'reseller_id': App.user.get("reseller")
                    }
                }
                );
                this.ActionsCollection = new ActionsCollection([], {
                    parameters: {
                        'reseller_id': App.user.get("reseller")
                    }
                }
                );
            }
            else if (App.user.get("customer")){
                this.WalletsCollection = new WalletsCollection();
                this.ActionsCollection = new ActionsCollection([], {
                    parameters: {
                        'customer_id': App.user.get("customer")
                    }
                }
                );
            }


            // Update collections limit to fetch all actions and wallet_actions in this page
            this.ActionsCollection.limit = 4;
            this.WalletsCollection.limit = 4;

            this.listenTo(this.ActionsCollection, 'fetch_complete', this._onFetch);
            this.listenTo(this.WalletsCollection, 'fetch_complete', this._onFetch2);
            this.ActionsCollection.fetch();

        },

        ui: function () {
            return {
                loadingButton: '#loading',
            };
        },
        onScroll : function () {
            var s = $(window).scrollTop(),
                d = $(document).height(),
                c = $(window).height();

            var scrollPercent = (s / (d - c)) * 100;

            if (scrollPercent > 99.5 && !this.loading && this.ui.loadingButton){
                this.loading = true;
                this.ui.loadingButton.addClass('loading');
                this.ActionsCollection.limit += 5;
                this.WalletsCollection.limit += 5;
                this.limit +=5;
                this.ActionsCollection.fetch();
            }
        },
        _onFetch: function(){ 
            this.WalletsCollection.fetch();      
        },
        _onFetch2: function(){
            var is_it_different = true;
            if (this.ActionsCollection.length + this.WalletsCollection.length < this.limit- 5){
                this.ActionsCollection.limit -= 5;
                is_it_different = false;
            }

            if (is_it_different){

                if (!App.user.get("customer")) {
                    this.ActionsCollection.add(this.WalletsCollection.toJSON());
                }

                this.ActionsCollection.comparator = function (model) {
                    return -new Date(model.get('created'));
                };
                this.ActionsCollection.sort();


                //this.ActionsCollection.models = this.ActionsCollection.models.reverse();

                this.timelineContainer.show(new ActionView({
                    collection: new ActionsCollection(this.ActionsCollection.first(this.limit)) ,
                }));
            }

            $(window).scrollTop($(window).scrollTop()-50);
            this.loading = false;
            this.ui.loadingButton.removeClass('loading');
        }, 
        regions: function() {
            return {
                timelineContainer: ".timeline-page",
            };
        },

    });
});
